<template>
    <div>
        <h3>Auto-Assign Rules</h3>
        <div v-if="!loading">
            <v-row class="mt-5">
                <v-col cols="4">
                    <v-select
                        v-model="uid"
                        :items="locators"
                        item-text="label"
                        item-value="uid"
                        outlined
                        label="Locator"
                        dense
                        class="locator-select"
                        @change="getAutoAssignRules"
                    />
                </v-col>
                <v-col
                    cols="8"
                    align="right"
                >
                    <router-link
                        to="/settings/auto-assign-rules/new"
                        class="text-decoration-none"
                    >
                        <v-btn
                            v-if="addRulePermission.includes(userRole)"
                            style="text-transform: none !important"
                            class="text-subtitle-2"
                            depressed
                            color="primary"
                        >
                            <v-icon color="white">
                                mdi-plus
                            </v-icon>
                            Add Rule
                        </v-btn>
                    </router-link>
                </v-col>
            </v-row>

            <div
                v-for="(list, account) in autoAssignRulesList"
                :key="account"
            >
                <div class="mt-6 mb-3 font-weight-medium">
                    {{ account }}<span class="list-count rounded-circle d-inline-block">{{ list.length }}</span>
                </div>
                <v-row
                    v-for="(item, index) in list"
                    :key="index"
                    class="mx-0 my-4 list-item"
                    @click="editRule(item)"
                >
                    <v-col
                        cols="11"
                        class=""
                    >
                        <span
                            v-if="!item.enabled"
                            class="disabled-capsule"
                        > Disabled </span>
                        <table class="px-3 py-4 list-table">
                            <tr>
                                <td>Name:</td>
                                <td>{{ item.name }}</td>
                            </tr>
                            <tr>
                                <td>Weight:</td>
                                <td>{{ item.weight }}</td>
                            </tr>
                            <tr>
                                <td>Center:</td>
                                <td>{{ getCenter(item.center_id) }}</td>
                            </tr>
                            <tr>
                                <td>Code:</td>
                                <td>{{ item.member_code === "*" ? "Any" : item.member_code }}</td>
                            </tr>
                            <tr>
                                <td>County:</td>
                                <td>{{ item.fips === "*" ? "Any" : getCounty(item.fips) }}</td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col
                        cols="1"
                        align="center"
                        justify="center"
                        class="list-item-arrow"
                    >
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-col>
                </v-row>
            </div>
        </div>
        
        <div
            v-if="loading"
            class="d-flex justify-center align-center w-100p"
            style="height: 70vh;"
        >
            <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
            />
        </div>
    </div>
</template>

<script>
import webtmsBackend from '@/services/webtmsBackend';

export default {
    name: 'AutoAssignRulesList',
    data() {
        return {
            uid: 'ALL',
            autoAssignRulesList: {},
            locators: [],
            loading: false,
            addRulePermission: ['SYSOP', 'Director', 'Administrator']
        };
    },
    computed: {
        counties() {
            return this.$store.getters.counties.map((item) => { return { name: `${item[3]}, ${item[2]}`, value: item [1] }; });
        },
        companyCenters() {
            return this.$store.getters.companyCenters;
        },
        userRole() {
            return this.$store.getters.user.ingroup;
        }
    },
    mounted() {
        this.$store.commit('SET_SELECTED_AUTO_ASSIGN_RULE', {});
        this.getOverviewAutoAssignRules();
        this.getAutoAssignRules();
    },
    methods: {
        editRule(rule) {
            this.$store.commit('SET_SELECTED_AUTO_ASSIGN_RULE', rule);
            this.$router.push('/settings/auto-assign-rules/edit');
        },
        async getOverviewAutoAssignRules() {
            const response = await webtmsBackend.getOverviewAutoAssignRules();
            this.locators = [{uid: 'ALL', account: 'ALL', label: 'Rules for All Locators'}, ...response.overviewAutoAssignRules.locators.map(item => ({...item, label: `${item.account} "${item.name}"` }))];
        },
        async getAutoAssignRules() {
            this.loading = true;
            const response = await webtmsBackend.getAutoAssignRules(this.uid);
            let list = {};
            for(let item of response.data) {
                if (!list[`${item.account} "${item.account_full_name}"`]) list[`${item.account} "${item.account_full_name}"`] = [];
                list[`${item.account} "${item.account_full_name}"`].push(item);
            }
            this.autoAssignRulesList = Object.keys(list).sort().reduce( (obj, key) => { obj[key] = list[key]; return obj; }, {} );
            this.uid = response.uid;
            this.loading = false;
        },
        getCounty(county) {
            let data = county.match(/.{1,5}/g);
            data = data.map(d => {
                let countyData = this.counties.find(item => item.value == d);
                return countyData.name;
            });
            return data.join(',');
        },
        getCenter(center) {
            let centerData = this.companyCenters.find(item => item.center_id == center);
            return centerData?.center_tag;
        },
    }
};
</script>

<style>
    .list-count {
        font-size: 14px;
        margin-left: 10px;
        border: 1px solid var(--ll-border);
        padding: 0 7px !important;
    }
    .list-item-arrow i {
        height: 100%;
    }
    .list-item {
        cursor: pointer;
        border-radius: 10px;
        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    }
    .list-table {
        padding: 12px 0;
    }
    .list-table td:first-child {
        width: 100px;
    }
    .list-table td:nth-child(2) {
        font-weight: 500;
    }
    .disabled-capsule {
        border-radius: 10px;
        color: red;
        border: 1px solid red;
        padding: 2px 10px;
        font-size: 14px;
        margin-left: 14px;
    }
    .locator-select .v-text-field__details {
        display: none;
    }
</style>
